import { ListItem } from '../../shared/list-confirmation/model/list-item';
import { TransferType } from '../transfers-other-banks/models/transferType.enum';
import { TransactionResponseStatus } from '../transfers-other-banks/transfer-response/models/transaction-response-status.enum';

export class Transfer {
	id: number;
	bankCode: number;
	bankDesc: string;
	homeAgency: string;
	homeAccount: string;
	destinationAgency: string;
	destinationAccount: string;
	value: number;
	description: string;
	date: Date;
	dateLabel: string;
	complement: string;
	goalSPB: number;
	goalTes: number;
	favoredCpfCnpj: string;
	favoredName: string;
	favoredRemember: boolean;
	transferType: TransferType;
	ownership: string;
	modality: string;
	securityAnswer: string;
	success: boolean;
	message: string;
	resumeList: Array<ListItem>;
	dateType: string;
	confirmationCode: number;
	situation: TransactionResponseStatus;

	constructor() {}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/models/transfer.ts